/**
* @see /client/containers/GiftCardCart/index.js
* @see /client/containers/_DeliveryAdd/index.js
* OrderSummary
*/

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { bool, func, shape } from 'prop-types';
import Button from '../Button';

const StyledSummary = styled.div`
background: ${(props) => props.theme.whiteColor};
    border: ${(props) => props.theme.gray89} solid 1px;
    border-radius: 5px;
  h1{
    font-size:17px;
    font-weight:700;
    background: ${(props) => props.theme.lightWhite};
    padding: 10px;
    border-radius: 5px 5px 0px 0px;
  }
  .border-bg{
  padding:20px;
  font-size:13px;
  dl{
    margin:0px 0px 0px 0px;
    padding-bottom:10px;
    dt{
      display: inline-block;
      width: 50%;
      margin:5px 0px;
      color: ${(props) => props.theme.mediumGrey};
    }
    dd{
      display: inline-block;
      width: 50%;
      margin:5px 0px;
      margin:0px;
      text-align:right;
      span{
        color:${(props) => props.theme.primaryColor};
        font-size:19px;
        font-weight:700;
      }
    }
  }
  }
  ${Button}{
    margin-top:10px;
    width:100%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:100%;
    };
    }
    .adv{
      width:100%;
      margin:10px 0px 0px 0px;
    }
`;

function OrderSummary(props) {
  const { orderObj, childHandler, isButtonShow = true, isOnlyMerchandise = false, lyraPgEnabled = false } = props;
  // if (!orderObj) {
  //   return <div />;
  // }
  // console.log("here orderobj..............", props);

  const {
    lyra_charges = 0,
    orderSummeryAmount = 0,
    orderSummeryPrice = 0,
    shipping_fee_cents = 0,
    client_id = '',
    discountPersent = 0,
    orderItemCount = 0,
  } = orderObj;

  return (
    <StyledSummary>
      <h1>Order Summary</h1>
      <div className="border-bg">
        <dl>
          {!lyraPgEnabled && (
            <Fragment>
              <dt>Items </dt>
              <dd>{orderItemCount}</dd>
            </Fragment>
          )}
          <dt> {lyraPgEnabled ? 'Amount' : 'Price'} </dt>
          <dd>
            {client_id === 'payment_gateway' && discountPersent > 0 ?
              (<del>{orderSummeryPrice}</del>) : (
                <span>Rs. {orderSummeryAmount}</span>
              )}
          </dd>
          <dt> {lyraPgEnabled ? 'Charges' : 'Shipping Charges'} </dt>
          <dd><span>Rs. {lyraPgEnabled ? (lyra_charges) : (shipping_fee_cents)}</span></dd>
          <dt>Total </dt>
          <dd><span>Rs. {lyraPgEnabled ? (orderSummeryAmount + lyra_charges) : (orderSummeryAmount + shipping_fee_cents)}</span></dd>
        </dl>
        {isButtonShow && (
          <div className="text-center">
            <Button type="primary" onClick={() => childHandler('checkOut')}> Checkout</Button>
          </div>)}
      </div>
      {/* {!isOnlyMerchandise ?
        <img src={endPoints.MOBIKWIK_VOUCHER} alt="no_image" className="adv" />
        : null } */}
    </StyledSummary>
  );
}

OrderSummary.propTypes = {
  lyraPgEnabled: bool,
  isButtonShow: bool,
  isOnlyMerchandise: bool,
  orderObj: shape({}),
  childHandler: func,
};

OrderSummary.defaultProps = {
  // childHandler: () => '',
  orderObj: {},
  isOnlyMerchandise: false,
  lyraPgEnabled: false,
};
export default OrderSummary;



// WEBPACK FOOTER //
// client/components/OrderSummary/index.js